import MemberContributorModel from './member_contributor_model';
export default Backbone.Collection.extend({
  model: MemberContributorModel
});